import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { YPoint } from '../components/YPoint';
import { YPolygon } from '../components/YPolygon';
import { YLineString } from '../components/YLineString';
/** Возвращает id для геообъекта вставляемого в яндекс карту */
export var getMapPointId = function getMapPointId(id) {
  return "map-point-".concat(id);
};

/** Возвращает html для геообъекта вставляемого в яндекс карту */
export var getLayoutFactoryClass = function getLayoutFactoryClass(instance, _ref) {
  var _ref$options = _ref.options,
    html = _ref$options.html,
    id = _ref$options.id;
  var pointId = getMapPointId(id);
  return instance.templateLayoutFactory.createClass("<div id=\"".concat(pointId, "\">").concat(html, "</div>"));
};

/** Преобразует наш объект настроек геообъекта в формат яндекса */
export var mapGeoObjectsToYGeoObjects = function mapGeoObjectsToYGeoObjects(instance, points) {
  return points.map(function (point) {
    var options = point.options,
      type = point.type,
      name = point.name;
    switch (type) {
      case 'Point':
        {
          var yPoint = new YPoint(_objectSpread(_objectSpread({}, options), {}, {
            name: name,
            height: options.height,
            width: options.width,
            coordinates: options.coordinates,
            component: getLayoutFactoryClass(instance, point)
          }));
          return yPoint.getOptions();
        }
      case 'Polygon':
        {
          var yPolygon = new YPolygon(_objectSpread(_objectSpread({}, options), {}, {
            name: name,
            coordinates: options.coordinates
          }));
          return yPolygon.getOptions();
        }
      case 'LineString':
        {
          var yLineString = new YLineString(_objectSpread(_objectSpread({}, options), {}, {
            name: name,
            coordinates: options.coordinates
          }));
          return yLineString.getOptions();
        }
    }
  });
};